var map = {
	"./nurse.vue": "./src/views/statistic/nurse.vue",
	"./nurse/nurseAccount.vue": "./src/views/statistic/nurse/nurseAccount.vue",
	"./nurse/nurseDetail.vue": "./src/views/statistic/nurse/nurseDetail.vue",
	"./orderList.vue": "./src/views/statistic/orderList.vue",
	"./orderList/orderDetail.vue": "./src/views/statistic/orderList/orderDetail.vue",
	"./orderList/prescriptionDetail.vue": "./src/views/statistic/orderList/prescriptionDetail.vue",
	"./pregnant.vue": "./src/views/statistic/pregnant.vue",
	"./pregnant/pregnantDetail.vue": "./src/views/statistic/pregnant/pregnantDetail.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/views/statistic sync recursive \\.vue$";